import { connect } from 'react-redux'
import Sentiments from './Sentiments.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    chartType: state.analyticsSentiments.chartType,
    granularity: state.analyticsSentiments.granularity,
    dateRange: state.analyticsSentiments.dateRange,
    customDateRange: state.analyticsSentiments.customDateRange,
    channelNameToFilter: state.analyticsSentiments.channelNameToFilter
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeChartType: chartType => () => dispatch(Actions.sentimentsChangeField('chartType', chartType)),
    onChangeGranularity: granularity => () => dispatch(Actions.sentimentsChangeField('granularity', granularity)),
    onMoveCustomDateRange: operation => () => dispatch(Actions.sentimentsMoveCustomDateRange(operation)),
    onChangeSelectField: field => e => dispatch(Actions.sentimentsChangeField(field, e.target.value)),
    onChangeCustomDateRange: ({ startDate, endDate }) => dispatch(Actions.sentimentsChangeDateRange(startDate, endDate))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sentiments)
